import { Menu, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getMenuItems, getFlatItems } from "../../config/appConfig";

export default function AppMenu({ onMenuClick, collapsed = false }) {
  const { i18n } = useTranslation();
  const [searchText, setSearchText] = useState('');
  const [selectedKeys, setSelectedKeys] = useState([]);

  // Get current language (default to 'en')
  const lang = i18n.language?.startsWith('mr') ? 'mr' : 'en';

  const menuItems = useMemo(() => getMenuItems(lang), [lang]);
  const flatItems = useMemo(() => getFlatItems(lang), [lang]);

  // Filter menu items based on search
  const filteredItems = useMemo(() => {
    if (!searchText.trim()) return menuItems;
    
    const search = searchText.toLowerCase();
    const matchingKeys = flatItems
      .filter(item => item.label.toLowerCase().includes(search))
      .map(item => item.key);

    return menuItems
      .map(section => ({
        ...section,
        children: section.children.filter(child => matchingKeys.includes(child.key)),
      }))
      .filter(section => section.children.length > 0);
  }, [searchText, menuItems, flatItems]);

  const handleClick = (e) => {
    setSelectedKeys([e.key]);
    onMenuClick(e.key);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {!collapsed && (
        <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <Input
            placeholder={lang === 'mr' ? "शोधा..." : "Search..."}
            prefix={<SearchOutlined style={{ color: 'rgba(255,255,255,0.45)' }} />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
          />
        </div>
      )}

      <div style={{ flex: 1, overflow: 'auto' }}>
        <Menu
          mode="inline"
          theme="dark"
          items={filteredItems}
          selectedKeys={selectedKeys}
          onClick={handleClick}
          inlineCollapsed={collapsed}
          style={{ background: 'transparent', borderRight: 'none' }}
        />
      </div>

      {!collapsed && (
        <div style={{ 
          padding: '12px', 
          borderTop: '1px solid rgba(255,255,255,0.1)',
          textAlign: 'center',
          color: 'rgba(255,255,255,0.45)',
          fontSize: '11px',
        }}>
          © 2025 GP Admin Panel
        </div>
      )}
    </div>
  );
}
